module.exports = __webpack_public_path__ + "static/sf-ui-medium-19f32eb50fb5a7891e67bcf1e8e9d064.woff2";